(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["features1"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('features-one')) {
    customElements.define('features-one', class extends HTMLElement {
      connectedCallback() {
        // Defer until the element's children are parsed, including editor reloads.
        this.frame = requestAnimationFrame(() => this.init());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
      }

      init() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const scroller = this.querySelector('.features1__scroller');
        if (!scroller) return;

        const normalize = path => path.replace(/\/+$/, '') || '/';
        this.querySelectorAll('a.features1__card').forEach(link => {
          const target = new URL(link.href, window.location.href);
          const current = target.origin === window.location.origin
            && normalize(target.pathname) === normalize(window.location.pathname)
            && (!target.search || target.search === window.location.search)
            && !target.hash;
          if (current) link.setAttribute('aria-current', 'page');
          else link.removeAttribute('aria-current');
        });

        // Touch and trackpad scrolling remain native. Mouse dragging is added here.
        let startX = 0;
        let startScroll = 0;
        let pointer = null;
        let dragged = false;
        let suppressClickUntil = 0;

        scroller.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          if (scroller.scrollWidth <= scroller.clientWidth) return;
          pointer = event.pointerId;
          startX = event.clientX;
          startScroll = scroller.scrollLeft;
          dragged = false;
          suppressClickUntil = 0;
        }, options);

        scroller.addEventListener('pointermove', event => {
          if (event.pointerId !== pointer) return;
          if (!(event.buttons & 1)) { finish(event); return; }
          const distance = event.clientX - startX;
          if (!dragged && Math.abs(distance) < 6) return;
          if (!dragged) {
            dragged = true;
            scroller.setPointerCapture(pointer);
            scroller.classList.add('is-dragging');
          }
          event.preventDefault();
          scroller.scrollLeft = startScroll - distance;
        }, options);

        const finish = event => {
          if (event.pointerId !== pointer) return;
          if (dragged) suppressClickUntil = Date.now() + 350;
          if (scroller.hasPointerCapture(pointer)) scroller.releasePointerCapture(pointer);
          pointer = null;
          dragged = false;
          scroller.classList.remove('is-dragging');
        };

        scroller.addEventListener('pointerup', finish, options);
        scroller.addEventListener('pointercancel', finish, options);
        scroller.addEventListener('lostpointercapture', finish, options);
        scroller.addEventListener('pointerleave', event => {
          if (!dragged) finish(event);
        }, options);
        scroller.addEventListener('dragstart', event => event.preventDefault(), options);
        scroller.addEventListener('click', event => {
          if (event.detail !== 0 && Date.now() < suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { ...options, capture: true });

        // The editor can reveal a selected block even when it is off-screen.
        this.addEventListener('shopify:block:select', event => {
          const item = event.target.closest('.features1__item');
          if (!item) return;
          const itemRect = item.getBoundingClientRect();
          const viewRect = scroller.getBoundingClientRect();
          scroller.scrollLeft += itemRect.left - viewRect.left
            - (scroller.clientWidth - itemRect.width) / 2;
        }, options);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
